import * as React from 'react';
import { partialDateFromDate } from 'neuro-utils';
import { formatPartialDate } from 'Utility/date';

import TileContentMaker from 'Components/DashboardTile/TileContentMaker';
import { useAppSelector } from 'Store/index';
import { ninmtFileTypes } from '../utils';
import { useIntl } from 'react-intl';

const title = (titleString: string) =>
  ({
    painAndSymptomMap: 'patientFiles.painAndSymptomMap',
  })[titleString];

const PatientFilesDash = ({ documents }: IOwnProps): React.JSX.Element | undefined => {
  const platform = useAppSelector(s => s.session.platforms?.selected);

  const sortedFiles = documents.toSorted((a, b) => {
    const aDate = a.date ? new Date(a.date) : new Date(a._docCreateDate);
    const bDate = b.date ? new Date(b.date) : new Date(b._docCreateDate);
    return bDate.valueOf() - aDate.valueOf();
  });

  let letRelevantFiles: Array<IDocumentWithTypeV2<'filestorefile'>> = [];

  if (platform === 'ninmt') {
    letRelevantFiles = sortedFiles.filter(f => ninmtFileTypes.includes(f.subType));
  }

  const { formatMessage } = useIntl();
  const fm = (id: string) => formatMessage({ id });

  return (
    <TileContentMaker
      type="recentList"
      data={letRelevantFiles.map(d => ({
        key: d._id,
        date: d.date ? formatPartialDate(partialDateFromDate(new Date(d.date))) : '',
        title: title(d.subType) ? fm(title(d.subType) ?? '') : '',
      }))}
    />
  );
};
interface IOwnProps {
  documents: IDocumentWithTypeV2<'filestorefile'>[];
}

export default PatientFilesDash;
